import { useEffect, useState } from 'react';

/**
 * Returns true when the referenced element is visible within the viewport.
 *
 * Uses IntersectionObserver with a generous rootMargin so blobs are fetched
 * slightly before the card enters view (smooth UX) and released only after
 * it is well outside (avoids thrashing on slow scrolls).
 */
const useInViewport = (
  ref: React.RefObject<Element | null>,
  rootMargin = '200px',
): boolean => {
  const [isInViewport, setIsInViewport] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsInViewport(entry.isIntersecting),
      { rootMargin },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, rootMargin]);

  return isInViewport;
};

export default useInViewport;
